import { Customer } from "features/organizations/customers/models/customer-models";
import { WSPermissions } from "../models/users-models";
import { Site } from "features/organizations/sites/models/sites-models";


export function groupPermissionsByCustomerAndSite(
  permissions: WSPermissions[],
  customers: Customer[],
  sites: Site[]
): Record<string, { customerName: string; sites: string[] }> {
  const tempResult: Record<string, { customerName: string; sites: string[] }> = {};

  const customerMap = new Map(customers.map(c => [c.id, c]));
  const siteToCustomerMap = new Map<string, { customerId: string; name: string }>();

  for (const customer of customers) {
    for (const site of customer.sites ?? []) {
      siteToCustomerMap.set(site.id, { customerId: customer.id, name: site.name });
    }
  }

  for (const { customerId, siteId } of permissions) {
    let resolvedCustomerId = customerId;
    let siteName: string | undefined;

    if (!resolvedCustomerId && siteId) {
      const mapping = siteToCustomerMap.get(siteId);
      if (!mapping) continue;
      resolvedCustomerId = mapping.customerId;
      siteName = mapping.name;
    }

    if (!resolvedCustomerId) continue;

    const customer = customerMap.get(resolvedCustomerId);
    if (!customer) continue;

    const entry = tempResult[resolvedCustomerId] ?? {
      customerName: customer.name,
      sites: [],
    };

    if (siteName && !entry.sites.includes(siteName)) {
      entry.sites.push(siteName);
    }

    tempResult[resolvedCustomerId] = entry;
  }

  // Sort customers and their sites
  return Object.fromEntries(
    Object.entries(tempResult)
      .sort(([, a], [, b]) => a.customerName.localeCompare(b.customerName))
      .map(([id, entry]) => [
        id,
        {
          customerName: entry.customerName,
          sites: entry.sites.sort((a, b) => a.localeCompare(b)),
        },
      ])
  );
}

